import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { RecurrentTaskUpdateType } from 'tasks/types'
import keys from './shared/keys'

interface Variables {
  id?: string
  storeId?: string
  assignedTo?: string
  dueDate?: string
  updateType?: RecurrentTaskUpdateType
  exceptionId?: string
}

export function useDeleteTask() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: deleteTask,
    onSuccess: async () => {
      // Invalidate relevant queries
      await client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function deleteTask({ id, dueDate, updateType }: Variables) {
    let url = `v2/tasks/custom/${id}`
    const params = new URLSearchParams()

    if (dueDate) {
      params.append('due_date', dueDate)
    }
    if (updateType) {
      params.append('update_type', updateType)
    }

    const queryString = params.toString()
    if (queryString) {
      url += `?${queryString}`
    }

    return server.delete(url)
  }
}
